<template lang="pug">
  bulma-accordion
    bulma-accordion-item
      p.title.is-4.has-text-weight-normal(slot='title')
        | Operador
      i.material-icons(slot='icon') more_vert
      .high(slot='content')
        .columns.card-row
          h4.title.is-4
            | {{ operador.nombre }}
        .columns.card-row
          .column.is-12
            .field
              label.label Teléfono
              .control.has-icons-left
                input.input.is-primary(
                  type='text', 
                  placeholder='Teléfono',
                  v-model="operador.telefono",
                  :disabled="isformPgDisabled"
                )
                .icon.is-small.is-left
                  i.fas.fa-mobile-alt
        .columns.card-row
          .column.is-12
            .field
              label.label Identificación
              .control.has-icons-left
                input.input.is-primary(
                  type='text', 
                  placeholder='INE-0121212121544',
                  v-model="operador.identificacion",
                  :disabled="isformPgDisabled"
                )
                .icon.is-small.is-left
                  i.far.fa-id-card
        .columns.card-row(v-if="operador.foto !==''")
          .column.is-12
            figure.image.is-128x128
              img(:src="getAvatar(operador.foto)")
        .columns.card-row(v-else v-show="isformPgEditing")
          .column.is-12
            span.tag.is-danger 
              b Aún no tiene Fotografía
        .columns.card-row(v-show="!isformPgEditing")
          .column.is-12
            file-pond(name='test' ref="pond" class-name='my-pond' label-idle='Pulse o arrastre el archivo aquí...' accepted-file-types='image/*' v-model="myFile")
        .columns.card-row
          button.button.is-warning(@click="editPg" v-show="isformPgEditing")
            | Editar
          | &nbsp
          button.button.is-dark(@click="salirOperador" v-show="isformPgEditing")
            | Salir
          | &nbsp
          button.button.is-info(@click="updatePg" v-show="isformPgUpdating")
            | Actualizar
          | &nbsp
          button.button.is-default(@click="cancelUpdPg" v-show="isformPgUpdating")
            | Cancelar

</template>

<script>
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  import vueFilePond from 'vue-filepond'
  import '../../../../node_modules/filepond/dist/filepond.min.css'
  import autotanquesServicesIRGE from '@/services/irge/autotanquesIRGE.js'

  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.min.js'
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.js'

  // Import styles
  import 'filepond/dist/filepond.min.css'
  import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

  const FilePond = vueFilePond( FilePondPluginFileValidateType, FilePondPluginImagePreview )

  export default {
    name: 'FormOperador',
    components: { FilePond, BulmaAccordion, BulmaAccordionItem },
    props: {
      operador: {
        type: Object,
        default: {}
      },
    },
    data() {
      return {
        myFile: [],
        file: '',
        isformPgDisabled: true,
        isformPgEditing: true,
        isformPgUpdating: false
      }
    },
    watch: {
      myFile() {
        console.log(this.myFile)
        if ( this.myFile.length > 0 ) {
          this.file = this.myFile[0].file
          //this.operador.foto = this.file.name
        }
      },
    },
    methods: {
      getAvatar (avatar) {
        let currentUrl = window.location.hostname
        let link = ''
        if ( typeof avatar === 'undefined') {
          link = `https://${currentUrl}/SCA_IRGE/images/operadores/user.png`
        } else {
          link = `https://${currentUrl}/SCA_IRGE${avatar}`
        }
        return link
      },
      editPg() {
        this.isformPgDisabled = false
        this.isformPgEditing = false
        this.isformPgUpdating = true
        this.$emit('updateOperador', 'edit')
      },
      updatePg() {
        this.isLoading = true
        if ( this.myFile.length > 0 ) {
          this.file = this.myFile[0].file
        } else {
          this.file = ''
        }
        autotanquesServicesIRGE.actualizarOperador(this.operador.id, this.operador.telefono, this.operador.identificacion, this.file)
          .then( resp => {
            console.log(resp)
            if ( resp.success ) {
              let toast = this.$toasted.show(`El Operador, ha sido actualizado.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'check',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    
                    toastObject.goAway(0)
                  }
                },
              })
              this.isformPgDisabled = true
              this.isformPgEditing = true
              this.isformPgUpdating = false
              this.isLoading = false
              this.myFile.length = 0
              this.file = ''
              this.$refs.pond.removeFile()
              this.$emit('updateOperador', 'save')
            } else {
              let toast = this.$toasted.show(`Error: ${resp.respuesta}.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'exclamation-triangle',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    
                    toastObject.goAway(0)
                  }
                },
              })
              this.isLoading = false
            }
          })
          .catch( e => console.log(e))

      },
      cancelUpdPg() {
        this.isformPgDisabled = true
        this.isformPgEditing = true
        this.isformPgUpdating = false
        this.$refs.pond.removeFile()
      },
      salirOperador () {
        this.$refs.pond.removeFile()
        this.$emit('updateOperador', 'cancel')
      }
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/FormOperador.vue